<form class="flex flex-col w-full overflow-auto" [formGroup]="ficheInterventionForm" (ngSubmit)="onFormSubmit()">
    <div class="grid grid-cols-1 xl:grid-cols-2 gap-4 my-4">
        <div>
            <mat-form-field class="w-full">
                <mat-label>Date de contact</mat-label>
                <input type="date" matInput formControlName="date_contact">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Date d'intervention</mat-label>
                <input type="date" matInput formControlName="date_intervention">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Catégorie d'intervention</mat-label>
                <mat-select formControlName="categorie_intervention">
                    <mat-option [value]="'Feu'">Feu</mat-option>
                    <mat-option [value]="'Eau'">Eau</mat-option>
                    <mat-option [value]="'Égout'">Égout</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Contenu rapporté Urgex</mat-label>
                <input type="text" matInput formControlName="contenu_rapporte_urgex">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Cause du sinistre</mat-label>
                <input type="text" matInput formControlName="cause_sinistre">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Camion usine</mat-label>
                <input type="text" matInput formControlName="camion_usine" placeholder="00:00">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Débris - Type d'équipement</mat-label>
                <mat-select formControlName="debris_type_equipement_id">
                    <mat-option [value]="debrisTypeEquipement.id" *ngFor="let debrisTypeEquipement of debrisTypesEquipements">{{debrisTypeEquipement.type}}</mat-option>
                </mat-select>
                <button type="button" class="ml-4" MatSuffix mat-flat-button [color]="'primary'" (click)="ajouterDebrisTypeEquipement()">
                    <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Débris - Quantité</mat-label>
                <mat-select formControlName="debris_quantite">
                    <mat-option [value]="null">Aucune</mat-option>
                    <mat-option [value]="'Plein'">Plein</mat-option>
                    <mat-option [value]="'Moitié'">Moitié</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Sacs à ordure</mat-label>
                <input type="number" min="0" matInput formControlName="sacs_ordure">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Eau aspiré</mat-label>
                <input type="text" matInput formControlName="eau_aspire">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Tyveks</mat-label>
                <input type="number" min="0" matInput formControlName="tyvek">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Masques</mat-label>
                <input type="number" min="0" matInput formControlName="mask">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Pompe submersible</mat-label>
                <input type="text" matInput formControlName="pompe_submersible">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full">
                <mat-label>Nettoyage</mat-label>
                <input type="text" matInput formControlName="pompe_submersible">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full col-span-2">
                <mat-label>Travaux à effectuer</mat-label>
                <textarea matInput formControlName="travaux_a_effectuer" cdkTextareaAutosize>
                </textarea>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full col-span-2">
                <mat-label>Recommandations</mat-label>
                <textarea matInput formControlName="recommendation" cdkTextareaAutosize>
                </textarea>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="w-full col-span-2">
                <mat-label>Tapis de protection</mat-label>
                <input type="number" min="0" matInput formControlName="tapis_de_protection">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full col-span-2">
                <mat-label>Couverture</mat-label>
                <input type="number" min="0" matInput formControlName="couverture">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="w-full col-span-2">
                <mat-label>Polythène</mat-label>
                <input type="text" matInput formControlName="polythene">
            </mat-form-field>
        </div>

        <ng-container *ngIf="isPolytheneFilled">
            <div>
                <mat-form-field class="w-full col-span-2">
                    <mat-label>Protection</mat-label>
                    <input type="text" matInput formControlName="protection">
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="w-full col-span-2">
                    <mat-label>Hauteur</mat-label>
                    <input type="text" matInput formControlName="hauteur">
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="w-full col-span-2">
                    <mat-label>Largeur</mat-label>
                    <input type="text" matInput formControlName="largeur">
                </mat-form-field>
            </div>
        </ng-container>

        <div>
            <mat-form-field class="w-full col-span-2">
                <mat-label>Restriction zone</mat-label>
                <input type="text" matInput formControlName="restriction_zone">
            </mat-form-field>
        </div>
    </div>

    <div class="flex items-center justify-between w-full border-t py-4">
        <div class="flex items-center">
            <div class="flex items-center mr-4" *ngIf="success || error">
                <ng-container *ngIf="success">
                    <mat-icon class="text-green-500" [svgIcon]="'heroicons_outline:check'"></mat-icon>
                    <span class="ml-2">La fiche de l'intervention a été mise à jour</span>
                </ng-container>
                <ng-container *ngIf="error">
                    <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                    <span class="ml-2">Erreur lors de l'enregistrement, réessayez!</span>
                </ng-container>
            </div>
            <button type="submit" mat-flat-button [color]="'primary'">Enregistrer</button>
        </div>
    </div>
</form>
